export default (): string => {
  const cookie = window.document.cookie
    .split("; ")
    .find((c) => c.startsWith("website_csrf"));
  if (!cookie) {
    throw new Error("csrf cookie not set");
  }
  return decodeURIComponent(cookie.split("=")[1]);
};
